import { LoginResolver } from './login.resolver';

export const resolvers = [LoginResolver];

export { LoginResolver };
